import React from 'react';
import { PackImage } from './PackImage';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-24 pb-16 px-4 bg-cream relative overflow-hidden" data-id="element-64">
      {/* Background glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-[100px] pointer-events-none" data-id="element-65"></div>

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-66">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-warm-900 mb-6 leading-tight" data-id="element-67">
          <span className="text-primary" data-id="element-68">🔥</span> Cociná platos deliciosos,
          crujientes y saludables en menos de 15 minutos usando tu Air Fryer.
        </h1>

        <p className="text-xl md:text-2xl text-warm-800 mb-4 font-medium max-w-3xl mx-auto" data-id="element-69">
          Descubrí más de 100 recetas fáciles que cualquiera puede preparar,
          incluso si no sabés cocinar.
        </p>

        <p className="text-lg text-warm-700 mb-12 max-w-2xl mx-auto" data-id="element-70">
          Comé rico sin culpa, evitá frituras llenas de aceite y sorprendé a
          todos con recetas rápidas, sanas y deliciosas.
        </p>

        <div className="mb-12" data-id="element-71">
          <PackImage data-id="element-72" />
        </div>

        <button onClick={scrollToOffer} className="bg-primary hover:bg-primary-hover text-white font-bold text-xl md:text-2xl py-5 px-8 md:px-12 rounded-xl shadow-[0_0_30px_rgba(212,133,10,0.3)] hover:shadow-[0_0_40px_rgba(212,133,10,0.5)] transition-all duration-300 hover:scale-105 w-full md:w-auto" data-id="element-73">
          QUIERO MIS RECETAS AHORA
        </button>
      </div>
    </section>;
}